<template>
  <div id="app"
       v-bind:class="{active: isOpen}"
  >
    <aside class="sidebar"
         v-bind:class="{active: isOpen}"
    >
      <a href="/" class="logo">
        <img src="./assets/logo.png"/>
      </a>
      <a href="javascript:;" class="menu__burger color--blue">
        <span class="opener"
              v-on:click="toggleMenu"
        >
          <i class="material-icons">menu</i>
          <span>Menü</span>
        </span>
        <span class="closer menu__burger--bg"
              v-on:click="toggleMenu"
        >
          <i class="material-icons">close</i>
        </span>
      </a>
      <div class="menu__sidebar text-left">
        <ul>
          <li><a href="#" class="color--blue">Home</a></li>
        </ul>
        <ul>
          <li><a href="#" class="color--blue">NFD</a></li>
          <li><a href="#" class="link">Meine Daten</a></li>
          <li><a href="#" class="link">Dienstplan</a></li>
          <li><a href="#" class="link">Sekretariat</a></li>
          <li>
            <ul>
              <li><a href="#" class="link">Teilnehmer</a></li>
              <li><a href="#" class="link">Login</a></li>
              <li><a href="#" class="link">Organisation</a></li>
              <li><a href="#" class="link">Dispensation</a></li>
              <li><a href="#" class="link">Dienstpflicht</a></li>
            </ul>
          </li>
        </ul>
        <ul>
          <li><a href="#" class="color--blue">Arzt</a></li>
          <li><a href="#" class="link">Dienstplan Manager</a></li>
          <li><a href="#" class="link">Dienstplan erfassen</a></li>
          <li><a href="#" class="link">docTrans</a></li>
          <li><a href="#" class="link">docChat</a></li>
          <li><a href="#" class="link">Kommunikation</a></li>
          <li><a href="#" class="link">Notfallnummern</a></li>
          <li><a href="#" class="link">Interne Publikation</a></li>
        </ul>
      </div>
    </aside>
    <router-view/>
  </div>
</template>

<script>
    export default {
        data () {
            return {
                isOpen: false
            }
        },
        name: 'App',
        methods: {
            toggleMenu: function(){
                this.isOpen = !this.isOpen;
            }
        }
    }
</script>

<style lang="scss">
  @import "./assets/scss/_base.scss";
  @import "./assets/scss/frontend/_frontend.scss";
  @import "./assets/scss/frontend/_common.scss";
  @import "./assets/scss/frontend/_sidebar.scss";
</style>


// WEBPACK FOOTER //
// src/App.vue